<template>
    <div class="number_row">
        <div class="num">{{ idx }}</div>
        <div class="content">{{ content }}</div>
    </div>
</template>
<script>
export default {
    props: {
        idx: {},
        content: {},
    },
};
</script>
<style lang="scss" scoped>
.number_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    background: var(--gray2);
    width: 100%;
    height: 76px;
    padding: 0 30px;

    .num {
        margin-right: 13px;
        font-size: 13px;
        font-weight: normal;
        font-family: 'Pretendard', sans-serif;
        letter-spacing: -0.04em;
        color: var(--white);

        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--orange);
        border-radius: 100px;
        width: 30px;
        height: 30px;
        flex: none;
    }

    .content {
        font-size: 18px;
        font-family: 'Pretendard', sans-serif;
        color: var(--black2);
        letter-spacing: -0.045em;
    }
}
</style>
